const defaultConfig = {
  VUE_APP_API_URL: 'http://localhost:3060/v1/data-lab',
  VUE_APP_AUTH_ADMIN_API_URL: 'http://localhost:3000/mfe/auth-admin/api',
};

const {
  VUE_APP_API_URL: API_URL,
  VUE_APP_AUTH_ADMIN_API_URL: AUTH_ADMIN_API_URL,
} = {
  ...defaultConfig,
  ...process.env,
} as Record<string, string>;

export interface ApiConfig {
  fullPath: string;
}

export const apiConfig: ApiConfig = {
  fullPath: API_URL,
};

export interface AuthAdminApiConfig {
  fullPath: string;
}

export const authAdminApiConfig: AuthAdminApiConfig = {
  fullPath: AUTH_ADMIN_API_URL,
};
